import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { black, grey500 } from 'styles/colors';
import React from 'react';

export const MailContainer = styled.div`
	display: flex;
	align-items: left;
	flex-direction: column;
	width: 100%;
	padding: 5px;
	border: 1px solid #ccc; /* grey border */
`;

export const Icon = styled.svg`
	width: 100px;
	height: 100px;
	fill: #28a745; /* green color */
	margin-right: 12px;
`;

export const Message = styled.p`
	color: #333; /* dark grey text */
	font-size: 16px;
	margin: 0;
	margin-top: 20px;
`;
export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 200px;
	margin-bottom: 19px;
	padding-right: 32px;
	> div {
		> div {
        border-radius: 0;
		}
  .ap-button-main {
    height: 32px;
  }
`;
export const Label = styled.td`
	color: ${grey500};
	font-size: 14px;
	line-height: 20px;
	vertical-align: top;
	width: 80px;
	font-weight: normal;
	padding: 10px 64px 10px 10px;
`;

export const Value = styled.td`
	color: ${black};
	font-size: 14px;
	font-weight: 500;
	line-height: 30px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
`;
export const Line = styled.tr``;
export const StyledTable = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const Textarea = styled.textarea`
	width: 90%;
	height: 70px;
	resize: none;
	border: 1px solid ${colors.grey300};
	background-color: transparent;
	color: ${colors.grey8};
	font-size: 16px;
	font-family: 'Roboto';
	line-height: 20px;
	appearance: none;
	padding: 7px 10px;
	box-sizing: border-box;
	&:hover {
		border-color: ${colors.green2};
		outline: none;
		background-color: ${colors.green0};
	}
	,z-index: 1;
	&:focus {
		border-color: ${colors.green2};
		outline: none;
		background-color: ${colors.green0};
	}
	&:active {
		border-color: ${colors.green2};
		outline: none;
	}
`;
export const Buttonwrapper = styled.div`
	display: flex;
	justify-content: center;
`;
export const EmailResp = styled.div`
	color: ${colors.red800};
	padding: 4px 0 0 5px;
	font-size: 14px;
`;
